export default {
  HIOPOSWEBSERVICES: 'https://hiopos-qa.saas.com.co/api/ec/v1',
  LOGS_URL: 'https://hiopos-qa.saas.com.co/logs/ecuador',
  HIOPOSWEBSERVICESCOMBINED: 'https://hiopos-qa.saas.com.co',
  HIOPOSREPORTSEC: 'https://hioposreports-dev-ec.saas.com.co',
}
